import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { map, Observable, shareReplay } from "rxjs";
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { FaseDeteccion } from "src/app/shared/model/gestion-proyectos/riesgos/fase-deteccion.model";
import { Periodicidad } from "src/app/shared/model/gestion-proyectos/riesgos/periodicidad.model";
import { Riesgos } from "src/app/shared/model/gestion-proyectos/riesgos/riesgo.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

// Angular core y formularios
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper'; // ⬅ NECESARIO para matStepperNext

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@Component({
    selector: 'app-descripcion-riesgo',
    templateUrl: './descripcion-riesgo.component.html',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatStepperModule,          // ⬅ agregado
        NgxMatSelectSearchModule
    ]
})
export class DescripcionRiesgoComponent {

    readonly faseDeteccion$: Observable<FaseDeteccion[]>;
    readonly periodicidad$: Observable<Periodicidad[]>;

    constructor(private service: ProyectosService,) {
        this.faseDeteccion$ = this.obtenerfaseDeteccion();
        this.periodicidad$ = this.obtenerPeriodicidad();
    }

    @Input() riesgo: Riesgos;
    @Input() primerGrupo: FormGroup;
    private obtenerfaseDeteccion(): Observable<FaseDeteccion[]> {
        return this.service.consultaGeneral(UrlConstantes.consultaFaseDeteccion).pipe(
            map((res) => res?.list ?? []),
            shareReplay({ bufferSize: 1, refCount: true })
        );
    }
    private obtenerPeriodicidad(): Observable<Periodicidad[]> {
        return this.service.consultaGeneral(UrlConstantes.consultaPeriodicidad).pipe(
            map((res) => res?.list ?? []),
            shareReplay({ bufferSize: 1, refCount: true })
        );
    }
}
